import Dashboard from './Dashboard/index';
import LoginForm from './LoginForm/index';
import UIDemo from './ui-demo';
import CompanyInfo from './Setup/CompanyInfo';
import Users from './Setup/Users';
import OrganisationChart from './Setup/OrganisationChart';
import EmailTemplates from './email/emailTemplates';
import EmailTemplatesCreation from './email/emailTemplatesCreation';
import {
  EmailCampaign,
  EditCampaign,
  NewCampaign
} from './email/emailCampaign';
import NewEmail from './email/newEmail';
import PermissionProfile from './Setup/PermissionProfile';
import Fields from './Setup/Fields';
import FindDuplicates from './FindDuplicates/index';
import Layouts from './Setup/PageLayout';
import { ObjectTask, ObjectTaskViewAll } from './ObjectTask/index';
import MergeLeads from './MergeLeads/index';
import MySetting from './MySetting/index';
import ConvertLeads from './ConvertLeads/index';
import ObjectList from './ObjectList/index';
import GlobalSearch from './GlobalSearch/index';
import ObjectView from './ObjectView/index';
import ObjectShare from './ObjectShare/index';
import ClientDetails from './ClientDetails/index';
import Task from './Task/index';
import Exceptions from './Exceptions/index';
import Conversion from './Conversion/index';
import Invoice from './Invoice/index';
import Attachment from './Attachment/index';
import ReportSetup from './ReportSetup/index';
import ReportFilters from './ReportFilters/index';
import ReportTableSetup from './ReportTableSetup/index';
import ReportPreview from './ReportPreview/index';
import RealTimeReport from './RealTimeReport/index';
import ReportList from './ReportList';
import ReportListSider from './ReportListSider';
import ReportListPanel from './ReportListPanel';
import RealTimeReport_Table from './RealTimeReport_Table';
import DashboardSettings from './DashboardSettings';
import DashboardSettings_Details from './DashboardSettings_Details';
import DashboardSettings_Slot from './DashboardSettings_Slot';
// Shared Components
import Section_SharedTo from './Section_SharedTo';
import IpWhiteLists from './Setup/IpWhiteLists';
import SearchLayout from './Setup/SearchLayout/index';
import GeneralSettings from './Setup/GeneralSettings';
import ObjectImport from './Setup/ObjectImport';
import ObjectExport from './Setup/ObjectExport';
import { ForgotPassword, ResetPassword, CheckEmail, HasBeenReset } from './Auth';
import AttachAccount from './AttachAccount';
import SetUpWelPage from './Setup/WelcomePage';
import WorkFlow from './Setup/WorkFlow';
import ApiToken from './Setup/ApiToken'

export {
  Attachment,
  Dashboard,
  LoginForm,
  UIDemo,
  CompanyInfo,
  Users,
  OrganisationChart,
  EmailTemplates,
  EmailTemplatesCreation,
  EmailCampaign,
  EditCampaign,
  NewCampaign,
  NewEmail,
  PermissionProfile,
  Fields,
  FindDuplicates,
  Layouts,
  ObjectTask,
  ObjectTaskViewAll,
  MySetting,
  MergeLeads,
  ConvertLeads,
  ObjectList,
  GlobalSearch,
  ObjectView,
  ObjectShare,
  ClientDetails,
  Task,
  Exceptions,
  Conversion,
  Invoice,
  ReportSetup,
  ReportFilters,
  ReportTableSetup,
  ReportPreview,
  RealTimeReport,
  ReportList,
  ReportListSider,
  ReportListPanel,
  Section_SharedTo,
  RealTimeReport_Table,
  DashboardSettings,
  DashboardSettings_Details,
  DashboardSettings_Slot,
  IpWhiteLists,
  SearchLayout,
  GeneralSettings,
  ObjectImport,
  ObjectExport,
  ForgotPassword,
  ResetPassword,
  CheckEmail,
  HasBeenReset,
  AttachAccount,
  SetUpWelPage,
  WorkFlow,
  ApiToken
};



// WEBPACK FOOTER //
// ./src/views/index.js